export default class ProductFormat {
  format(data) {
    const PRODUCT = [];

    data.forEach(response => {
      // const beforFormat = function () {
      //
      //   if (response.Name === "Páginas Amarillas Web") {
      // return "Paginas Amarillas";
      //   } else if (response.Name === "Business Register Web") {
      //     return "business register";
      //   } else if (response.Name === "Amcham Online") {
      //     return "amchamdr online";
      //   } else {
      //     return response.Name;
      //   }
      // };

      // const responseFormat = slugify(beforFormat());
      let obj = {
        productId: response.ProductId,
        name: response.Name,
        class: response.BookCode,
        logo: response.iconPath,
        subscriberId: response.SubscrId,
        businessUnitId: response.BusinessUnitId,
        googleAccountId: response.googleAccountId,
        isActived: response.IsActived,
        expirationDate: response.ExpirationDate,
        spotifyAccountId: response.spotifyAccountId,
        linkedinAccountId: response.linkedinAccountId,
        googleMyBusinessProfileId: response.googleMyBusinessProfileId,
        infopaginasClientId: response.infopaginasClientId,
        tiktokAccountId: response.tiktokAccountId,
      };

      PRODUCT.push(obj);
    });
    return PRODUCT;
  }
}
